import React from 'react';
import {Headline} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './FilterSection.module.scss';

type FilterSectionProps = {
  title: string;
  children: React.ReactNode;
};

function FilterSection({title, children}: FilterSectionProps) {
  return (
    <div className={styles.filterSection}>
      <Headline size="xs">{translate(title)}</Headline>
      {children}
    </div>
  );
}

export default FilterSection;
